import React from "react";

import { scaleLinear } from "@visx/scale";

export const COLOR_SCALE_RANGE = [
  "#FC668D",
  "#EFA54E",
  "#47CC7C",
  "#19C79F",
  "#19C79F",
];

const getColor = (value: number): React.CSSProperties["fill"] => {
  return scoreColorScale(value);
};

const scoreColorScale = scaleLinear<string>({
  domain: [50, 70, 80, 90, 100],
  range: COLOR_SCALE_RANGE,
  clamp: true,
});

export default getColor;
